import { ApiResponse, Device } from "../types/api";
import { http } from "./http";

interface ListDevicesParams {
  skip?: number;
  take?: number;
  sort?: string;
  boxId?: string
}

// GET /devices
export const listDevices = async (
  params: ListDevicesParams = {}
): Promise<{ list: Device[], total: number }> => {

  const query = new URLSearchParams();

  if (params.skip != null) query.set("skip", String(params.skip));
  if (params.take != null) query.set("take", String(params.take));
  if (params.boxId != null) query.set('boxId_like', params.boxId);

  const response = await http.get<ApiResponse<Device[]>>(`/devices?${query.toString()}`)

  const { data } = response;
  if (!data.success || !data.data) {
    throw new Error(data.error || "Load failed");
  }

  const total = Number(response.headers["x-total-count"] ?? 0);

  return { list: data.data, total };
}

// GET /devices/:id
export const getDevice = async (id: number): Promise<Device> => {
  const { data } = await http.get<ApiResponse<Device>>(`/devices/${id}`)
  if (!data.success || !data.data) throw new Error(data.error || 'Not found')
  return data.data
}

// POST /devices
export const createDevice = async (payload: Partial<Device>) => {
  const { data } = await http.post<ApiResponse<Device>>('/devices', payload)
  if (!data.success || !data.data) throw new Error(data.error || 'Create failed')
  return data.data
}

// PUT /devices/:id
export const updateDevice = async (id: number, payload: Partial<Device>) => {
  const { data } = await http.put<ApiResponse<Device>>(`/devices/${id}`, payload)
  if (!data.success || !data.data) throw new Error(data.error || 'Update failed')
  return data.data
}

// DELETE /devices/:id  (optional)
export const deleteDevice = async (id: number) => {
  const { data } = await http.delete<ApiResponse<null>>(`/devices/${id}`)
  if (!data.success) throw new Error(data.error || 'Delete failed')
  return true
}
